import { CPMSliderMaxValue, CPMSliderMinValue } from '@/constants/forecaster';
import EstimationSlider from '@/pages/Forecaster/Estimation/components/EstimationSlider';
import { useAppSelector } from '@/store/hooks';
import { CircularProgress, Paper } from '@mui/material';
import PropTypes from 'prop-types';
import { useCallback, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import EstimationTabs from './EstimationTabs';
import Frequency from './components/Frequency';

const Estimation = ({ forecasterData, currentChannel }) => {
  const { control, setValue } = useFormContext();

  const { channelsDataRequestId } = useAppSelector(state => state.forecaster);
  const isAverageToggledKey = useMemo(() => `${currentChannel}.isAverageToggled`, [currentChannel]);
  const averageCpmKey = useMemo(() => `${currentChannel}.averageCpm`, [currentChannel]);

  const isAverageToggled = useWatch({ control, name: isAverageToggledKey });
  const averageCpm = useWatch({ control, name: averageCpmKey });

  const changeCpm = useCallback(
    (_, value) => {
      setValue(averageCpmKey, value);
    },
    [averageCpmKey, setValue],
  );

  return (
    <Paper className='flex flex-col justify-start items-center px-3 py-4 gap-3 shadow-md-lg break-after-page'>
      <div className='flex w-full justify-between'>
        <h2 className='text-[#171725] text-lg font-semibold'>Estimation</h2>
        {channelsDataRequestId ? <CircularProgress size={30} className='justify-self-end self-end' /> : null}
      </div>
      <EstimationTabs forecasterData={forecasterData}>
        {isAverageToggled && (
          <EstimationSlider
            minValue={CPMSliderMinValue}
            maxValue={CPMSliderMaxValue}
            handleChange={changeCpm}
            value={averageCpm}
          />
        )}
        <Frequency />
      </EstimationTabs>
    </Paper>
  );
};

Estimation.propTypes = {
  forecasterData: PropTypes.object,
  currentChannel: PropTypes.string,
};

export default Estimation;
